import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { useToaster } from "src/_common/hooks/actions/common/appToasterHook";
import { useAppLoader } from "src/_common/hooks/actions/common/appLoaderHook";
import { useUserApi } from "src/_common/hooks/actions/user/appUserApiHook";
import "./AutoLogin.css";

interface AutoLoginParams {
  email: string;
}

const AutoLogin: React.FC = () => {
  const { email: encodedEmail } = useParams<AutoLoginParams>();
  const history = useHistory();
  const toast = useToaster();
  const { showLoader, hideLoader } = useAppLoader();
  const userApi = useUserApi();
  const [error, setError] = useState<string>("");

  useEffect(() => {
    if (encodedEmail) {
      handleAutoLogin();
    } else {
      setError("Invalid login link");
      setTimeout(() => {
        history.push("/employer-login");
      }, 2000);
    }
  }, [encodedEmail]);

  const handleAutoLogin = async () => {
    try {
      showLoader();

      // Decode base64 email
      let decodedEmail = "";
      try {
        decodedEmail = atob(encodedEmail);
      } catch (e) {
        throw new Error("Invalid email format");
      }

      console.log("Decoded email:", decodedEmail);

      // Call auto-login API using the existing API hook pattern
      userApi.callAutoLogin(
        { email: decodedEmail },
        (message: string, resp: any) => {
          console.log("Auto login response:", resp);

          // The login saga will handle storing tokens and user details automatically
          // Similar to regular login flow

          // Show success message
          //   toast.success(message || "Login successful! Redirecting...");

          // Redirect to dashboard after a short delay
          setTimeout(() => {
            hideLoader();
            history.push("/dashboard");
          }, 1000);
        },
        (error: string) => {
          console.error("Auto login error:", error);
          hideLoader();

          setError(error || "Auto login failed");
          toast.error(error || "Auto login failed");

          // Redirect to login page after error
          setTimeout(() => {
            history.push("/");
          }, 3000);
        }
      );
    } catch (error: any) {
      console.error("Auto login error:", error);
      hideLoader();

      const errorMessage = error?.message || "Auto login failed";
      setError(errorMessage);
      toast.error(errorMessage);

      // Redirect to login page after error
      setTimeout(() => {
        history.push("/");
      }, 3000);
    }
  };

  return (
    <div className="autologin-container">
      <div className="autologin-content">
        {!error ? (
          <>
            <div className="autologin-spinner">
              <div className="spinner"></div>
            </div>
            <h2>Logging you in...</h2>
            <p>Please wait while we authenticate your session.</p>
          </>
        ) : (
          <>
            <div className="autologin-error">
              <i className="fa fa-exclamation-circle"></i>
            </div>
            <h2>Login Failed</h2>
            <p>{error}</p>
            <p className="redirect-message">Redirecting to login page...</p>
          </>
        )}
      </div>
    </div>
  );
};

export default AutoLogin;
